import get from 'lodash/get'

export const isDialogOpen = (state, id) => get(state, ['ui', 'dialog', 'open']) === id;
export const isDialogLoading = (state, id) => get(state, ['ui', 'dialog', 'loading']);


// WEBPACK FOOTER //
// ./src/selectors/dialog.js